import {defineStore} from 'pinia';
import MockResourcesResearch from 'src/mock-data/MockResourcesResearch.json';
import {ResourceService} from 'src/services/ResourceService';
import {Services} from 'src/services/service-manager';
import {ref} from 'vue';
import {useGrouperStore} from 'stores/grouper-store';
import {AnalyzeDrgRequestDto} from 'src/contracts/analyzeDrgRequestDto';

export const useResourcesStore = defineStore('resourcesStore', () => {

    const analysisData = ref<any>();

    function getResourcesResearches(code: string) {
        if (code !== 'D69.9') {
            return MockResourcesResearch['D69.9'];
        } else {
            return MockResourcesResearch.default;
        }
    }

    async function getMsDrgAnalysis(): Promise<void> {
        const info = useGrouperStore().primaryDRG;
        const patientData = useGrouperStore().patient;

        const diagnosis = useGrouperStore().diagnosisCodes;
        const cc_present = diagnosis.some(diagnose => diagnose.risk?.includes('CC'));
        
        const request: AnalyzeDrgRequestDto = {
            drg_analysis_input: {
                drg: info?.drg,
                grouper_version: grouperVersion(info?.grouper_version),
                coding_system: patientData?.codingSystem,
                diagnoses:{
                    diagnosis: diagnosis
                },
                procedures:{
                    procedure: useGrouperStore().procedureCodes
                },
                los: patientData?.los,
                cc_is_present: cc_present
            }
        }

        const resourceService = Services.service(ResourceService);
        analysisData.value = await resourceService.analyzeDRG(request);
    }

    function grouperVersion(version: string | undefined | null) : string {
        return version?.slice(0, -1) + '.' + version?.slice(-1);
    }

    return {
        getResourcesResearches,
        getMsDrgAnalysis,
        analysisData
    }
})
